import { css } from 'styled-components';

export const GradientTextColor = css`
    background: linear-gradient(90deg, #ffffff 2%, ${({ theme }) => theme.c.primary01} 50.5%, #ffffff 100%);
    background-clip: text;
    -webkit-text-fill-color: transparent;
    mask-image: linear-gradient(90deg, #ffffff 2%, ${({ theme }) => theme.c.primary01} 50.5%, #ffffff 100%);
`;

export const GradientTextColor2 = css`
    background: linear-gradient(90deg, #FDB541 0%, #FCD763 31%, #F3EAC4 62.5%, #F4B742 97%);
    background-clip: text;
    -webkit-text-fill-color: transparent;
    mask-image: linear-gradient(90deg, #FDB541 0%, #FCD763 31%, #F3EAC4 62.5%, #F4B742 97%);
`;

export const GradientBackground = css`
    background: ${({ theme }) => theme.c.linearGradientBg};
`;

export const CardStyles = css`
    background: linear-gradient(0deg, #1c1c1c, #1c1c1c),
        linear-gradient(
            31.82deg,
            rgba(247, 147, 26, 0) 78.13%,
            rgba(247, 147, 26, 0.15) 89.06%,
            rgba(106, 13, 173, 0.24) 100%
        );
    background-blend-mode: screen;
`;

export const ModalStyles = css`
    background: linear-gradient(38deg, #000 80%, rgba(106, 13, 173, 0.36) 90%, #8c546f 100%);
    /* background: radial-gradient(circle at top right, rgba(247, 147, 26, 0.4) 0%, rgba(106, 13, 173, 0.4) 8%, #000 15%); */
    background-blend-mode: screen;
`;

export interface GradientBorderProps {
    colors?: string[];
    borderWidth?: number;
    borderRadius?: number;
    gradient?: string;
    padding?: string;
}
export const GradientBorder = css<GradientBorderProps>`
    border-radius: ${({ borderRadius = 20 }) => `${borderRadius}px`};
    padding: ${({ padding }) => padding || '16px 20px'};
    position: relative;
    background-color: transparent;
    z-index: 0;

    &::before {
        content: '';
        position: absolute;
        top: 0px;
        left: 0px;
        right: 0px;
        bottom: 0px;
        border-radius: inherit;
        padding: ${({ borderWidth = 1 }) => `${borderWidth}px`};
        background: ${({ gradient, colors, theme }) =>
            gradient
                ? gradient
                : `linear-gradient(90deg, ${colors?.[0] || theme.c.primary01} 0%, ${
                      colors?.[1] || theme.c.primary02
                  } 100%)`};
        mask: linear-gradient(white 0 0) content-box, linear-gradient(white 0 0);
        -webkit-mask: linear-gradient(white 0 0) content-box, linear-gradient(white 0 0);
        -webkit-mask-composite: xor;
        mask-composite: exclude;
        z-index: -1;
    }
`;

export const AksharFont = css`
    font-family: 'Akshar' !important;
`;
